import {
    encodedArrayCodec,
    PresetSearchParamsCustomDefaultValues,
    withModeCodec,
} from "@impero-com/ui/domain";

export const TESTING_ACTIVITY_TABLE_STATE_STORAGE_KEY =
    "userTestingActivityList";

export const TESTING_ACTIVITY_LIST_COLUMN_IDS = {
    TESTING_ACTIVITY: "testingActivity",
    TESTING_PROGRAM: "testingProgram",
    ASSIGNMENT_TYPE: "assignmentType",
    SAMPLING_TAGS: "samplingTags",
} as const;

export const testingActivityListTableDefaultValues: PresetSearchParamsCustomDefaultValues =
    {
        sorting: [
            {
                id: TESTING_ACTIVITY_LIST_COLUMN_IDS.TESTING_ACTIVITY,
                desc: false,
            },
        ],
    };

export const testingActivityListColumnFiltersCodecMap = {
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.TESTING_ACTIVITY]:
        withModeCodec(encodedArrayCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.TESTING_PROGRAM]:
        withModeCodec(encodedArrayCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.ASSIGNMENT_TYPE]:
        withModeCodec(encodedArrayCodec),
    [TESTING_ACTIVITY_LIST_COLUMN_IDS.SAMPLING_TAGS]:
        withModeCodec(encodedArrayCodec),
};
